var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.isShowPc)?_c('pcView'):_c('h5View')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }